export const getBasePath = (pathname: string) => {
  const parts = pathname.split("/");
  return `/${parts[1]}`;
};
